import { getGameConfig } from '../../../config/gameConfig';
import { getList, t } from '../../../i18n/translations';
import { hashSeed, mulberry32 } from './random';

export function buildSettlementName(
    seed: number,
    pos: { q: number; r: number; s: number },
): string {
    const lang = getGameConfig().ui.language;
    const adjectives = getList(lang, 'names.settlement.adjectives');
    const nouns = getList(lang, 'names.settlement.nouns');
    if (adjectives.length === 0 || nouns.length === 0) {
        return t(lang, 'settlement.defaultName');
    }
    const rng = mulberry32(hashSeed(seed, pos.q, pos.r, pos.s));
    const adj = adjectives[Math.floor(rng() * adjectives.length)];
    const noun = nouns[Math.floor(rng() * nouns.length)];
    if (!adj || !noun) return t(lang, 'settlement.defaultName');
    return `${adj} ${noun}`;
}
